import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderMobile from "../headerMobile";
import { Outlet } from "react-router-dom";
import Classes from "./styles/style.module.css";
import SideNav from "../sideNav";
import BackDrop from "../backDrop";
import { useScrollDetector } from "../../Hooks/scrollDetect";
import { useLocation } from "react-router-dom";
import useIsMobile from "../../Hooks/getIsMobile";
import { useRoute } from "../../context/RouteContext";
import useMediaQuery from "@mui/material/useMediaQuery";

const PageContainer = (props) => {
  const location = useLocation();
  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isDesktopHome = location.pathname === "/" && isDesktop;
  const isMobile = useIsMobile();
  const { setPreviousRoute } = useRoute();

  useEffect(() => {
    setPreviousRoute(location.pathname);
  }, [location.pathname, setPreviousRoute]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location]);

  const { hideHeader_footer } = useSelector(({ common }) => common);

  const [openSideBar, setOpenSideBar] = useState(false);
  const top = useScrollDetector();

  const sideBarToggler = () => {
    setOpenSideBar(!openSideBar);
  };

  return (
    <main
      className={`${!hideHeader_footer ? Classes.mainContainer : ""} ${location.pathname === "/" ? Classes.homeContainer : ""} ${location.pathname !== "/lig/map" ? "" : Classes.mapFooter
        }`}
      style={{ overflow: 'hidden !important' }}
    >
      <SideNav open={openSideBar} sideBarToggler={sideBarToggler} />
      {
        !isDesktopHome && !hideHeader_footer &&
        !location.pathname.includes("/rb1403") && (
          <HeaderMobile
            sideBarToggler={sideBarToggler}
            top={top}
            fcm={props.fcm}
          />
        )}
      {/* <HeaderMobile sideBarToggler={sideBarToggler} top={top} fcm={props.fcm} /> */}
      <Outlet />
      <BackDrop show={openSideBar} toggleMenu={sideBarToggler} />
    </main>
  );
};

export default PageContainer;
